import React from "react";

interface EditConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EditConfirmationModal: React.FC<EditConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-3 sm:p-4 overflow-y-auto">
      {/* Gradient Border Wrapper - responsive */}
      <div
        className="relative w-full max-w-[820px] my-auto rounded-2xl sm:rounded-3xl md:rounded-[40px] p-[1px] flex-shrink-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(130,135,152,0) 0%, rgba(130,135,152,0.4) 100%)",
        }}
      >
        {/* Modal - responsive padding */}
        <div className="relative bg-[#0e0e10] overflow-hidden rounded-2xl sm:rounded-3xl md:rounded-[40px] py-8 sm:py-12 md:py-16">
          {/* Top glow - responsive size */}
          <div
            className="absolute left-1/2 -translate-x-1/2 blur-3xl opacity-80 w-[280px] sm:w-[360px] md:w-[480px] h-[100px] sm:h-[120px] md:h-[150px]"
            style={{
              top: "-50px",
              background:
                "linear-gradient(226deg, #1B76FF 12%, #2BFAA3 94%)",
            }}
          />

          {/* Content - responsive padding & text */}
          <div className="relative z-10 px-4 sm:px-8 md:px-12 lg:px-[72px]">
            <h2 className="text-[#FFFFFF] text-center text-xl sm:text-2xl md:text-[32px] font-semibold">
              Heads Up!
            </h2>

            <div className="mt-4 sm:mt-6 space-y-3 sm:space-y-4 text-sm sm:text-base md:text-[20px] leading-[160%] text-white/75">
              <p>
                Please note that once a campaign is published, only the artist
                name, title, and budget can be edited.
              </p>

              <p>
                After making your changes, remember to republish the campaign
                to take effect.
              </p>

              <p>
                Meta Ads may take a few hours and in rare cases, a few days – to
                review your campaign before it becomes active again!
              </p>
            </div>

            {/* Buttons - stack on mobile, row on desktop */}
            <div className="mt-6 sm:mt-10 flex flex-col-reverse sm:flex-row justify-center gap-3 sm:gap-5">
              {/* Secondary Button */}
              <button
                onClick={onCancel}
                className="w-full sm:w-auto h-12 sm:h-[48px] px-6 sm:px-8 rounded-full bg-white text-[#020202] text-sm sm:text-[16px] font-semibold transition"
              >
                Never mind, no edits needed
              </button>

              {/* Primary Button */}
              <div
                className="w-full sm:w-auto rounded-full p-[1px]"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(88, 242, 169, 0.2) 0%, #58F2A9 100%)",
                }}
              >
                <button
                  onClick={onConfirm}
                  className="w-full h-12 sm:h-[48px] px-6 sm:px-8 rounded-full text-white text-sm sm:text-[16px] font-semibold transition"
                  style={{
                    background: "linear-gradient(to right, #1C3941, #58F2A9)",
                  }}
                >
                  Proceed with the edits
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditConfirmationModal;
